import { InjectionToken } from '@angular/core';

export interface PointToGeoJsonHandler<T> {
	toGeoJsonProperties(document: T): Record<string, any>;
	getCoordinates(document: T): [number, number];
}

export const POINT_TO_GEOJSON_HANDLER = new InjectionToken<PointToGeoJsonHandler<any>>(
	'POINT_TO_GEOJSON_HANDLER'
);
